module.exports = __webpack_public_path__ + "static/media/35_A.a1b622af.png";